import { createSlice } from "@reduxjs/toolkit"

export const accountInfoSlice = createSlice({
  name: "accountInfo",
  initialState: null,
  reducers: {
    set: (state, action) => action.payload
  }
})

export const { set: setAccountInfo } = accountInfoSlice.actions

export default accountInfoSlice.reducer
